export default __webpack_public_path__ + "static/media/key2.4eef0a1d.png";